export default "__VITE_ASSET__CgP_$IfH__"